import React from 'react'

import * as cp from '../../../comps'

import salesSlickImg from '../../../img/salesSlick.png'

//@ts-ignore
import styles from './SalesSlick.module.css'

export interface SalesSlickProps {
  company: string
  noPDF?: boolean
}

export default React.memo<SalesSlickProps>(function SalesSlick({
  company,
  noPDF,
}) {
  return (
    <cp.PageReport autoHeight company={company} companyBorder hPad noPDF={noPDF}>
      <img
        alt="HomeCam vs. traditional providers"
        className={styles['img']}
        src={salesSlickImg}
      />
    </cp.PageReport>
  )
})
